import type { ReactNode } from 'react';
import type { Country } from '@/models/country';
import { useCountryPickRates } from '@/hooks/useCountryPickRates';
import { useProgressionAwards } from '@/hooks/useProgressionAwards';
import { useWc26Fixtures } from '@/hooks/useWc26Fixtures';
import { useWc26GameResults } from '@/hooks/useWc26GameResults';
import { TeamDetailProvider } from './TeamDetailContext';
import { TeamDetailModal } from './TeamDetailModal';

/**
 * Provider + single modal instance for team detail across the app.
 *
 * Loads the canonical fixture schedule, deduped results, and progression awards internally
 * so every entry point shows the same tournament totals and fixture history.
 */
export function TeamDetailRoot(props: {
  children: ReactNode;
  /** User's 10-team list when known (profile, map, shared list). */
  countryList?: Country[];
}) {
  const pickRatesByCountry = useCountryPickRates();
  const fixtures = useWc26Fixtures();
  const gameResults = useWc26GameResults();
  const progressionAwards = useProgressionAwards();

  return (
    <TeamDetailProvider
      fixtures={fixtures}
      gameResults={gameResults}
      progressionAwards={progressionAwards}
      countryList={props.countryList}
      pickRatesByCountry={pickRatesByCountry}
    >
      {props.children}
      <TeamDetailModal />
    </TeamDetailProvider>
  );
}
